(function (angular, app) {
   "use strict";

   angular.module(app.modules.common.name)
       .constant(app.modules.common.constants.gameenum,

       {
          gameType : {
             individual : "Individual"
             , team : "Team"
          }
          , scoringType : {
             stroke : "Stroke"
             , bestBall : "BestBall"
             , variableBestBall : "VariableBestBall"
             , scramble : "Scramble"
             , alternateShot : "AlternateShot"
           
          }
          , holeType : {
             eighteen : "EighteenHoles"
             , nine : "NineHoles"
          }

       }

       );
}(angular, app));
